import React from 'react';
import PropTypes from 'prop-types';
import { uniq } from 'lodash-es';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';

import { PasswordInput } from 'site-modules/profile/components/settings/change-password/password-input';
import { FirebaseErrors } from 'site-modules/shared/components/profile/firebase-errors';
import { LoadingSpinner } from 'site-modules/profile/components/shared/loading-spinner/loading-spinner';

const PASSWORD_FIELDS = [
  {
    id: 'oldPassword',
    label: 'Enter your current password*',
  },
  {
    id: 'newPassword',
    label: 'New password*',
  },
  {
    id: 'confirmPassword',
    label: 'Confirm password*',
  },
];

const PASSWORD_FIREBASE_ERROR_MAP = {
  'auth/wrong-password': 'Your current password is incorrect.',
};

export function PasswordForm({
  passwords,
  onChange,
  onSubmit,
  onCancel,
  toggleForgotPassword,
  toggleSignModal,
  validationClasses = {},
  firebaseError = {},
  errorMap,
  showActiveSpinner,
  isDeletedUser = false,
}) {
  const errorValues = uniq(Array.from(errorMap.values()));

  return (
    <form onSubmit={onSubmit} className={classnames({ 'form-disabled': showActiveSpinner })}>
      <p>
        Enter your current password or{' '}
        <a
          className="text-primary-darker"
          href="forgot-password"
          onClick={toggleForgotPassword}
          data-tracking-id="recover_password"
          data-no-refresh
          rel="nofollow"
        >
          send a reset email to yourself
        </a>
      </p>

      {PASSWORD_FIELDS.map(({ id, label }) => (
        <PasswordInput
          key={id}
          name={id}
          value={passwords[id]}
          label={label}
          validationClass={validationClasses[id]}
          onChange={onChange}
          errorCode={firebaseError && firebaseError.code}
          disabled={isDeletedUser}
        />
      ))}
      <ul
        className={classnames('change-password-form-error ps-1 small', {
          'text-danger': errorMap.size || firebaseError,
        })}
      >
        {errorValues && errorValues.map(value => <li key={value}>{value}</li>)}
        {firebaseError && (
          <FirebaseErrors
            error={firebaseError}
            customErrorMap={PASSWORD_FIREBASE_ERROR_MAP}
            toggleSignModal={toggleSignModal}
          />
        )}
      </ul>
      <div className="text-end">
        <Button size="sm" color="link" className="text-capitalize size-16 me-0_5" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="submit"
          size="sm"
          color="outline-primary-b"
          className="size-16"
          data-tracking-id="change_password"
          disabled={showActiveSpinner || isDeletedUser}
        >
          Save
          {showActiveSpinner && (
            <LoadingSpinner wrapperClassNames="d-inline-block ps-0_25" spinnerClassNames="submit-form-spinner" />
          )}
        </Button>
      </div>
    </form>
  );
}

PasswordForm.propTypes = {
  passwords: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  toggleForgotPassword: PropTypes.func.isRequired,
  toggleSignModal: PropTypes.func.isRequired,
  validationClasses: PropTypes.shape({}),
  firebaseError: PropTypes.shape({}),
  errorMap: PropTypes.shape({}).isRequired,
  showActiveSpinner: PropTypes.bool.isRequired,
  isDeletedUser: PropTypes.bool,
};
